// Division별 브랜딩 설정
const BRANDING = {
  B2C: {
    name: '애니핏 플러스',
    nameCompact: '애니핏플러스',
    logo: 'https://glucofit-image.s3.ap-northeast-2.amazonaws.com/anyfitlogo.png',
    deepLink: 'https://sfplus.page.link/plus',
    caresenseRedirect: {
      prod: 'https://anyfitplus.samsungfire.com/promotion/html/mobile/mobile_link.html?targetUrl=NPGEHCC30106.do',
      release:
        'https://anyfitplus-r.samsungfire.com/promotion/html/mobile/mobile_link.html?targetUrl=NPGEHCC30106.do',
      qa: 'https://anyfitplus-q.samsungfire.com:13045/promotion/html/mobile/mobile_link.html?targetUrl=NPGEHCC30106.do',
      dev: 'https://anyfitplus-d.samsungfire.com:13045/promotion/html/mobile/mobile_link.html?targetUrl=NPGEHCC30106.do',
    },
  },
  B2B: {
    name: '애니핏 프로',
    nameCompact: '애니핏프로',
    logo: 'https://glucofit-image.s3.ap-northeast-2.amazonaws.com/anyfit-pro-logo.png',
    deepLink:
      'https://anyfitpro.samsungfire.com/promotion/html/mobile/mobile_link.html',
    caresenseRedirect: {
      prod: 'https://anyfitpro.samsungfire.com/promotion/html/mobile/mobile_link.html',
      release:
        'https://anyfitpro.samsungfire.com/promotion/html/mobile/mobile_link.html',
      qa: 'https://anyfitpro-d.samsungfire.com:13065/promotion/html/mobile/mobile_link.html',
      dev: 'https://anyfitpro-d.samsungfire.com:13065/promotion/html/mobile/mobile_link.html',
    },
  },
};

/**
 * 토큰에서 division 추출
 * @returns {'B2C' | 'B2B'} division 값 (기본값: 'B2C')
 */
export function getDivisionFromToken() {
  // 1. 먼저 별도 저장된 division 확인 (API 응답에서 저장된 값)
  const storedDivision = localStorage.getItem('division');
  if (storedDivision && ['B2B', 'B2C'].includes(storedDivision)) {
    return storedDivision;
  }

  // 2. JWT에서 추출 시도
  const token = localStorage.getItem('token');
  if (!token) return 'B2C';

  try {
    // base64url → base64 변환 후 디코딩
    // JWT 표준은 base64url 사용 (-와 _), atob()는 표준 base64만 지원 (+와 /)
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const payload = JSON.parse(atob(base64));
    return payload.division || 'B2C';
  } catch {
    return 'B2C';
  }
}

/**
 * 현재 division에 맞는 브랜딩 설정 반환
 * @returns {Object} 브랜딩 설정 (name, nameCompact, logo, deepLink, caresenseRedirect)
 */
export function getBranding() {
  const division = getDivisionFromToken();
  return BRANDING[division] || BRANDING.B2C;
}
